import React, { useState, useEffect, useCallback } from "react"
import AsyncSelect from "react-select/async"
import { Controller } from "react-hook-form"
import { fetchFinanceGroupLi } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  if (!str) return ""
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const FinanceGroupType = ({
  control,
  name,
  onSelectChange,
  disabled,
  target,
  placeholder,
  clearable,
  showCreateOption = false,
  onCreate,
  parentChk,
  refreshKey,
  currentId,
}) => {
  const [options, setOptions] = useState([])
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [inputValue, setInputValue] = useState("")
console.log(`currentId`, currentId);

  // Fetch options for a given page and search
  // const fetchOptions = useCallback(
  //   async (search = "", pageNum = 1, concat = false) => {
  //     const res = await fetchFinanceGroupLi({
  //       searchText: search,
  //       parent_id: parentChk,
  //       currnet_id: currentId,
  //       page: pageNum,
  //     })
  //     const dataArr = res?.data?.data || []
  //     const mapped = dataArr.map(dta => ({
  //       label: dta?.name ? ucfirst(dta.name) : "",
  //       value: dta.id,
  //       ...dta,
  //     }))
  //     setHasMore((res?.data?.last_page || 1) > pageNum)
  //     let finalOptions = mapped
  //     if (showCreateOption && onCreate && !parentChk && pageNum === 1) {
  //       finalOptions = [
  //         {
  //           label: "Create",
  //           value: "create_new_group",
  //           isCreateOption: true,
  //         },
  //         ...finalOptions,
  //       ]
  //     }
  //     if (concat) {
  //       setOptions(prev => [...prev, ...finalOptions])
  //       return [...options, ...finalOptions] // for callback
  //     } else {
  //       setOptions(finalOptions)
  //       return finalOptions
  //     }
  //   },
  //   [parentChk, showCreateOption, onCreate, currentId] // <-- NO options here!
  // )

    const fetchOptions = useCallback(
    async (search = "", pageNum = 1, concat = false) => {
      const res = await fetchFinanceGroupLi({
        searchText: search,
        parent_id: parentChk,
        current_id: currentId, // fixed key name
        page: pageNum,
      })
      const dataArr = res?.data?.data || []
      const mapped = dataArr.map(dta => ({
        label: dta?.name ? ucfirst(dta.name) : "",
        value: dta.id,
        ...dta,
      }))
      setHasMore((res?.data?.last_page || 1) > pageNum)
      let finalOptions = mapped
      if (showCreateOption && onCreate && !parentChk && pageNum === 1) {
        finalOptions = [
          {
            label: "Create",
            value: "create_new_group",
            isCreateOption: true,
          },
          ...finalOptions,
        ]
      }
      if (concat) {
        let combined = null
        setOptions(prev => {
          combined = [...prev, ...finalOptions]
          return combined
        })
        return combined
      } else {
        setOptions(finalOptions)
        return finalOptions
      }
    },
    [parentChk, showCreateOption, onCreate, currentId]
  )

  // Initial load and when input changes
  const loadOptions = useCallback(
    (input, callback) => {
      setInputValue(input)
      setPage(1)
      fetchOptions(input, 1, false).then(callback)
    },
    [fetchOptions]
  )

  // On scroll to bottom, fetch next page if available
  const handleMenuScrollToBottom = () => {
    if (hasMore) {
      const nextPage = page + 1
      setPage(nextPage)
      fetchOptions(inputValue, nextPage, true)
    }
  }

  // Reset options when parentChk or refreshKey changes
  useEffect(() => {
    setOptions([])
    setPage(1)
    setHasMore(true)
    setInputValue("")
    // Initial load for page 1 with empty search
    fetchOptions("", 1, false)
  }, [parentChk, refreshKey, fetchOptions, currentId])

  // Reset options when input is cleared
  const handleInputChange = (input, { action }) => {
    if (action === "input-change") {
      setInputValue(input)
    }
    if (action === "input-clear") {
      setInputValue("")
      setPage(1)
      fetchOptions("", 1, false)
    }
    return input
  }

  const handleChange = (selected, onChange) => {
    if (selected?.isCreateOption) {
      if (onCreate) onCreate()
      onChange(null)
    } else {
      onChange(selected)
      if (onSelectChange) onSelectChange(selected)
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ref, value } }) => (
        <AsyncSelect
          defaultOptions={options}
          loadOptions={loadOptions}
          placeholder={placeholder || "Select Group"}
          inputRef={ref}
          onChange={selected => handleChange(selected, onChange)}
          value={value}
          isClearable={clearable}
          isDisabled={disabled}
          classNamePrefix="react-select"
          className="elevate-dropdown"
          menuPortalTarget={document.querySelector(target || "body")}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 9999 }),
          }}
          onMenuScrollToBottom={handleMenuScrollToBottom}
          onInputChange={handleInputChange}
        />
      )}
    />
  )
}

export default FinanceGroupType
